module.exports = __webpack_public_path__ + "img/shade-designer-logo-light.880f5439.png";